module.exports = "<h1 mat-dialog-title>Applied filters</h1>\n<div mat-dialog-content>\n  <div #dialogBody></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/dialogs/show-all-filters-dialog/show-all-filters-dialog.component.html
// module id = ./src/app/projects/project/dialogs/show-all-filters-dialog/show-all-filters-dialog.component.html
// module chunks = main